import BB_Header from './header'
import BB_Cart from './cart'
import Cookies from 'js-cookie'

export default class BB_Elements {
    constructor() {
        BB_Elements.search_btn = jQuery('.ob-search-icon')

        BB_Elements.footer_sticky_close_btn = jQuery('.ob-footer-sticky-close-btn')

        BB_Elements.init()
    }
    static init() {
        console.log('elements.js init');

        BB_Elements.search_btn.on('click', BB_Elements.search_toggle)
        BB_Elements.header_scroll()

        BB_Elements.newsletter_placeholder()
        BB_Elements.footer_sticky_close_btn.on('click', BB_Elements.footer_sitcky_newsletter_close)
        BB_Elements.footer_sitcky_newsletter()
    }
    static search_toggle() {
        const search_wrap = jQuery(this).closest('.ob-search-wrap');

        search_wrap.toggleClass('ob-search-active')
    }
    static header_scroll() {
        // header hide
        let lastScrollTop = 0;
        let scrollChecker;
        var $ = jQuery;

        $(window).on('scroll', (function (event) {
            var st = $(this).scrollTop();
            var header_scroll_wrap = $('.ob-header-scroll')
            let start_height = 200;
            if (st > start_height) {

                if (st > lastScrollTop) {
                    if (scrollChecker != 'down') {
                        header_scroll_wrap.removeClass('ob-header-scroll-active')
                        scrollChecker = 'down';
                    }
                } else {
                    if (scrollChecker != 'up') {
                        header_scroll_wrap.addClass('ob-header-scroll-active')
                        scrollChecker = 'up';
                    }
                }
                lastScrollTop = st;
            } else {
                header_scroll_wrap.removeClass('ob-header-scroll-active')
            }

        }));
    }
    static newsletter_placeholder() {
        let newsletter = jQuery('.mailster-email')

        newsletter.attr('placeholder', 'email@email.com')
    }
    static footer_sitcky_newsletter() {
        let footer_sticky = jQuery('.ob-footer-sticky');
        let get_cookie = Cookies.get('sitcky_footer_newsletter');

        console.log(get_cookie);

        if (!get_cookie) {
            footer_sticky.removeClass('ob-inactive')
            footer_sticky.addClass('ob-active')
        }

    }
    static footer_sitcky_newsletter_close() {
        let footer_sticky = jQuery(this).closest('.ob-footer-sticky')

        footer_sticky.addClass('ob-inactive')
        footer_sticky.removeClass('ob-active')

        Cookies.set('sitcky_footer_newsletter', 1, { expires: 30 })
        console.log(Cookies.get('sitcky_footer_newsletter'));
    }
}